import { render, staticRenderFns } from "./Mingganci.vue?vue&type=template&id=3b7a8e3d&scoped=true&"
import script from "./Mingganci.vue?vue&type=script&lang=js&"
export * from "./Mingganci.vue?vue&type=script&lang=js&"
import style0 from "./Mingganci.vue?vue&type=style&index=0&id=3b7a8e3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a8e3d",
  null
  
)

export default component.exports